import { render, staticRenderFns } from "./venueMap.vue?vue&type=template&id=b23106b4&scoped=true&"
import script from "./venueMap.vue?vue&type=script&lang=js&"
export * from "./venueMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23106b4",
  null
  
)

export default component.exports